var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-center"},[_c('div',{ref:"chart",staticClass:"chart-container",attrs:{"id":"total-chart","data-test-id":"total-chart"}})]),_vm._v(" "),_c('ChartLegend',{attrs:{"items":_vm.legend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }